import { CHART_INTERACTIVE_MODE } from 'ChartApp/ts/features/charts-shared/constants';
import { DATE_SELECTION_DEFAULT, SAVED_FUND_CHART_BOOLEAN_KEYS, SAVED_FUND_CHART_CORRELATIONS_INTEGER_FIELDS, } from 'ChartApp/ts/features/fundamental-chart/constants';
import { convertNestedStringToBoolean } from 'NewAngular/utils/state-utils';
export function sanitizeFundChart(chart) {
    // For backwards compatibility, make sure all chart's states are properly typed
    // If we are missing enhancements, set default values
    const sanitizedChart = { ...chart };
    if (chart.state.annotations === undefined)
        sanitizedChart.state.annotations = {};
    if (chart.state.annualizedReturns === undefined)
        sanitizedChart.state.annualizedReturns = false;
    if (chart.state.chartType === undefined)
        sanitizedChart.state.chartType = CHART_INTERACTIVE_MODE;
    if (chart.state.dateSelection === undefined)
        sanitizedChart.state.dateSelection = DATE_SELECTION_DEFAULT;
    // Convert nested strings 'true' / 'false' to booleans
    convertNestedStringToBoolean(sanitizedChart.state);
    // Check boolean values for empty strings and set to false
    SAVED_FUND_CHART_BOOLEAN_KEYS.forEach((k) => {
        const field = k;
        sanitizedChart.state[field] = !!sanitizedChart.state[field];
    });
    // Convert any integer fields in correlation objects to integers
    if (chart.state.correlations && chart.state.correlations.length > 0) {
        const correlations = [];
        chart.state.correlations.forEach((correlation) => {
            // Copy each correlation so we do not affect existing state
            const correlationCopy = { ...correlation };
            SAVED_FUND_CHART_CORRELATIONS_INTEGER_FIELDS.forEach((k) => {
                const field = k;
                if (correlation[field]) {
                    correlationCopy[field] = parseFloat(correlation[field]);
                }
            });
            correlations.push(correlationCopy);
        });
        sanitizedChart.state.correlations = correlations;
    }
    // Remove 'quotes' key / value since it is no longer used as a state parameter.
    delete sanitizedChart.state.quotes;
    return sanitizedChart;
}
